import { GridItem } from "commons/ui/Grid";

import FiltersContainer from "components/ui/FiltersContainer";
import SearchInput from "components/ui/SearchInput";

import { RugianoProjectListHook } from "hooks/list/useRugianoProjectsList";

function RugianoProjectsTableFilters({
    rugianoProjectsListHook,
}: {
    rugianoProjectsListHook: RugianoProjectListHook;
}) {
    const { onSearchFilterChange, filterSearchHook } = rugianoProjectsListHook;

    const { applyFilters, clearFilters, form } = filterSearchHook;

    return (
        <FiltersContainer applyFilters={applyFilters} clearFilters={clearFilters}>
            <GridItem className={"col-xs-12-4"}>
                <SearchInput
                    placeholder={"Cerca"}
                    value={form.search.name}
                    onChange={onSearchFilterChange}
                    filterInput
                />
            </GridItem>
        </FiltersContainer>
    );
}

export default RugianoProjectsTableFilters;
